export type AppRole =
  | 'super_admin'
  | 'admin'
  | 'branch_admin'
  | 'staff'
  | 'branch_staff'
  | 'rider'
  | 'kitchen'
  | 'customer_service'
  | 'dispatcher'
  | 'customer'

export function getRoleBasedRedirectPath(roles: Array<AppRole | string> | undefined): string {
  if (!roles || roles.length === 0) return '/'

  const rolesList = roles.map(r => (typeof r === 'string' ? r : String(r)))

  if (rolesList.includes('rider')) return '/rider/dashboard'
  if (rolesList.includes('kitchen')) return '/admin/kitchen-display'
  if (rolesList.includes('customer_service')) return '/admin/customer-service'
  if (rolesList.includes('dispatcher')) return '/admin/dispatcher'

  if (
    rolesList.includes('super_admin') ||
    rolesList.includes('admin') ||
    rolesList.includes('branch_admin') ||
    rolesList.includes('staff') ||
    rolesList.includes('branch_staff')
  ) {
    return '/admin/dashboard'
  }

  return '/'
}

export default getRoleBasedRedirectPath
